/**
 * SMSコードを規定上限回数以上間違えた場合のエラー
 * @see: https://my-color.esa.io/posts/755
 */
import { BaseError } from '@/util/base-error'

export class ExceedSmsCodeAuthTrialTimesError extends BaseError {
  constructor(
    message: string,
    readonly label: string
  ) {
    super(message)
  }
}
